export const ALLOWED_FILE_TYPES_PERFORMANCE_VISUALIZATION = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
export const ALLOWED_FILE_TYPES_AVATAR_PICTURE = ['image/jpeg', 'image/png', 'image/webp'];
export const ALLOWED_FILE_TYPES_TENANT_LOGO = ['image/png', 'image/jpeg'];
export const ALLOWED_FILE_TYPES_EXTERNAL_MATERIAL_LOGO = ['image/png', 'image/jpeg', 'image/webp', 'image/gif'];
export const ALLOWED_FILE_TYPES_REPORT_COVER_IMAGE = ['image/png', 'image/jpeg', 'image/webp'];
export const APPEARANCE_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

export const ENTRY_ATTACHMENT_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
export const ENTRY_ATTACHMENT_DOCUMENT_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/markdown',
  'text/plain',
];
export const ALLOWED_FILE_TYPES_ENTRY_ATTACHMENT = [
  ...ENTRY_ATTACHMENT_IMAGE_TYPES,
  ...ENTRY_ATTACHMENT_DOCUMENT_TYPES,
];
// Browser-encoded thumbnails: WebP, or JPEG where the canvas cannot encode WebP (Safari).
export const ALLOWED_FILE_TYPES_THUMBNAIL = ['image/webp', 'image/jpeg'];

export const ENTRY_ATTACHMENT_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp', '.gif'];
export const ENTRY_ATTACHMENT_DOCUMENT_EXTENSIONS = ['.pdf', '.docx', '.xlsx', '.md', '.txt'];
export const ENTRY_ATTACHMENT_EXTENSIONS = [
  ...ENTRY_ATTACHMENT_IMAGE_EXTENSIONS,
  ...ENTRY_ATTACHMENT_DOCUMENT_EXTENSIONS,
];

export const SCHOOL_IMPORT_EXTENSIONS = ['.csv'];

// A photo, scan or PDF of a class list; CSV and text files are read in the browser and sent as text. The browser
// shrinks photos below the limit.
export const ALLOWED_FILE_TYPES_STUDENT_IMPORT = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];
